module.exports = __webpack_public_path__ + "static/img/180153_2.5327d88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/180153_2.jpg
// module id = sp5B
// module chunks = 1